import React, { ReactNode, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import KC_Button, {
  KC_ButtonSize
} from "../../../designsystem/KC_Button/KC_Button";
import { configAnimation, JETPACK_CONFIG } from "../../../utils/routes/routes";
import VideoIcon from "../../../components/Icons/VideoIcon";
import { LANGUAGE, tt } from "../../../utils/i18n/i18n";
import { baseSteps } from "../../03_Onboarding/helpers/constants";
import VideoModal from "../../../components/modal/VideoModal/VideoModal";
import KC_Heading2 from "../../../designsystem/typography/KC-Heading/KC_Heading2";
import { KC_Text_Sizes, KC_Weights } from "../../../designsystem/ds_commons";
import KC_Text from "../../../designsystem/typography/KC_Text/KC_Text";
import { buildPathWithTrackingId } from "../../../utils/routing/routingUtils";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import "./styles.scss";

interface Props {
  title?: string;
  description?: string;
  titleButton?: ReactNode;
}

export default function MobileDashboardHeader(props: Props) {
  const history = useHistory();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const location = useLocation();

  const videoURL = useMemo(() => {
    const step = baseSteps?.find(
      (s) => location.pathname === `${configAnimation}/${s.pathName}`
    );
    // @ts-ignore
    return step?.videoURL?.[LANGUAGE] || step?.videoURL?.["en"] || null;
  }, [location.pathname]);

  const handleOpenVideo = () => {
    if (!videoURL) {
      alert(tt("error"));
      return;
    }
    void NiceModal.show(VideoModal, {
      videoURL
    });
  };

  return (
    <div className="d-flex d-sm-none flex-column mobile-dashboard-header pt-2 px-4">
      <div className="d-flex flex-row justify-content-between st-gap pb-4">
        <KC_Button
          id="back-to-home-btn"
          size={KC_ButtonSize.Large}
          isInverted={true}
          className="d-flex back-to-home"
          text={tt("returnToHome")}
          extraStyle={{
            width: "unset !important"
          }}
          onClick={() => {
            history.push(
              buildPathWithTrackingId(
                JETPACK_CONFIG,
                accountToDisplay?.trackingID
              )
            );
          }}
        />

        {!!videoURL && (
          <KC_Button
            size={KC_ButtonSize.Large}
            showIconOnTheLeft={true}
            customIcon={<VideoIcon />}
            text={tt("prizes_configurator_see_video")}
            isInverted={true}
            extraStyle={{
              width: "unset !important"
            }}
            onClick={handleOpenVideo}
          />
        )}
      </div>

      {(props.title || props.description) && (
        <div className="flex-grow-1 mb-3 mt-3">
          <div className="d-flex align-items-center mb-2 gap-sm">
            <div className="d-flex flex-row align-items-center w-100 st-gap">
              <KC_Heading2 text={props.title} className="flex-grow-1" />
              {props.titleButton}
            </div>
          </div>
          <KC_Text
            size={KC_Text_Sizes.lg}
            weight={KC_Weights.reg}
            text={props.description}
            className="d-block text-secondary"
          />
        </div>
      )}
    </div>
  );
}
